type ProvidedI18nMessages = Record<string, string>;

export default function getMessages(): ProvidedI18nMessages {
    window.__JSD_I18N_MESSAGES = window.__JSD_I18N_MESSAGES || {};
    return window.__JSD_I18N_MESSAGES;
}
